import { Injectable } from '@angular/core';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { ApiController } from 'app/controllers/api-controller.interface';
import { HttpGet, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';

@Injectable()
export class PessoaController implements ApiController<Pessoa>{
	
	create(entity: Pessoa): Promise<Pessoa> {
		throw new Error("Method not implemented.");
	}
	update(entity: Pessoa): Promise<Pessoa> {
		throw new Error("Method not implemented.");
	}

	constructor() { }
	
	async find(filtros?:IFilter):Promise<Array<Pessoa>>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/pessoas/find',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Pessoa>()
			)
		);
		return await quark.call();
	}

	async getPessoaByCPFCNPJ(nrCpfCnpj: string): Promise<Pessoa>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoas/getNrCpfCnpj/:nrCpfCnpj',
                    environment: environment,
                    pathParams: new JSONData({nrCpf: nrCpfCnpj})
                }),
            }),
            new HttpResponse(
                new Pessoa()
            )
        );

        return quark.call();
    }
	
	async get(cdPessoa:number):Promise<any>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/pessoas/:cdPessoa',
					environment: environment,
					pathParams: new JSONData({cdPessoa: cdPessoa})
				}),
			}),
			new HttpResponse(
				new Object()
			)
        );
        return await quark.call();
	}

	async getArquivos(cdPessoa:number):Promise<any>{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/pessoas/:cdPessoa/arquivos',
					environment: environment,
					pathParams: new JSONData({cdPessoa: cdPessoa})
				}),
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        return await quark.call();
	}

	async getPermissionario(filtros?: IFilter): Promise<Array<Pessoa>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoafisicajuridica/permissionarios',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Pessoa>()
            )
        );

        return await quark.call();
    }

	
}